import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { FormioComponent, ConfirmationDialogComponent } from 'dp-formio';
import { ToastrService } from 'ngx-toastr';
import { filter, finalize, take, takeUntil } from 'rxjs';
import { showToast } from '../../../toast.helper';
import { BaseComponent } from '../../base.component';
import { DecisionInput } from '../../models/decision-input.model';
import { ExecuteVisitType } from '../../models/execute-visit.model';
import { ExecutivePlan } from '../../models/executive-plan.model';
import { CriterionsService } from '../../services/criterions.service';
import { AddEditExecutivePlanComponent } from './add-edit-executive-plan/add-edit-executive-plan.dialog';
import { ItimadCriterionsService } from '../../services/itimad-criterions.service';

@Component({
  selector: 'app-executive-plan',
  templateUrl: './executive-plan.component.html',
  styleUrls: ['./executive-plan.component.scss', '../data-table.scss']
})
export class ExecutivePlanComponent extends BaseComponent implements OnInit {
  @ViewChild(FormioComponent) formioComponent: FormioComponent;
  decisionInput$ = this.criterionsService.decisionInputs$;
  isLoadingResults: boolean = false;
  institutionEntries = ExecuteVisitType.InstitutionEntries;

  dataSource: ExecutivePlan[] = [];
  displayedColumns = [
    'clause',
    'startDate',
    'endDate',
    'responsibleName',
    'responsiblePosition',
    'actions'
  ];

  constructor(private matDialog: MatDialog,
    private criterionsService: CriterionsService,
    private itimadCriterionsService: ItimadCriterionsService,
    private translateService: TranslateService,
    private toastrService: ToastrService) { super(); }

  ngOnInit() {
    this.getData();
  }

  showPlan(decisionInput: DecisionInput, plan: ExecutivePlan = null, isViewOnly: boolean = false, index: number = null) {
    const dir = this.translateService.currentLang == 'ar' ? 'rtl' : 'ltr';
    this.matDialog.open(AddEditExecutivePlanComponent, {
      width: 'min(80%,900px)',
      direction: dir,
      maxHeight: '90vh',
      autoFocus: false,
      restoreFocus: false,
      data: {
        viewOnly: isViewOnly,
        model: plan || new ExecutivePlan(),
        dir: dir
      }
    })
      .afterClosed()
      .pipe(
        filter(data => !!data),
        take(1)
      )
      .subscribe((result: any) => {
        const model: ExecutivePlan = {
          ...result,
          visitId: decisionInput.visitMetaData.visitId,
          visitKey: decisionInput.visitMetaData.visitKey,
          deleted: false
        };

        if (plan) {
          this.dataSource[index] = model;
          this.dataSource = [...this.dataSource];
        } else
          this.dataSource = [...this.dataSource, model];
      });
  }

  undo(index: number) {
    this.dataSource[index].deleted = false;
    this.dataSource = [...this.dataSource];
  }
  deletePlan(index: number) {
    this.matDialog.open(ConfirmationDialogComponent, {
      direction: this.translateService.currentLang == 'ar' ? 'rtl' : 'ltr',
      data: {
        message: 'forms.common.Are you sure to delete this item',
        buttonText: {
          ok: 'forms.common.yes',
          cancel: 'forms.common.cancel',
        }
      },
      width: "40vw",
      panelClass: 'confirmation-dialog',
    })
      .afterClosed()
      .pipe(filter(data => !!data))
      .subscribe(() => {
        // this.dataSource.splice(index, 1);
        this.dataSource[index].deleted = true;
        this.dataSource = [...this.dataSource];
      });
  }

  submit(decisionInput: DecisionInput) {
    this.isLoadingResults = true;
    this.itimadCriterionsService.saveExecutivePlan(this.dataSource)
      .pipe(finalize(() => this.isLoadingResults = false))
      .subscribe(model => {
        this.getData();
        // this.dataSource = [...model];
        showToast(this.toastrService,
          this.translateService.instant("forms.common.Criteria.Saved done"),
          this.translateService.instant("forms.common.Criteria.Saved Successfully"),
          false
        );
      });
  }

  private getData() {
    this.isLoadingResults = true;
    this.itimadCriterionsService.getExecutivePlan(this.criterionsService.decisionInputs$.getValue().visitMetaData.visitKey)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.isLoadingResults = false)
      )
      .subscribe(data => {
        this.dataSource = data;
        this.updateResultData();
      });
  }
  private updateResultData() {
    const value = this.criterionsService.results$.getValue();
    value.executivePlan = this.dataSource;
    this.criterionsService.results$.next(value);
  }
}
